import React from 'react';

const AssessmentResults = ({answers}) => {

  const renderAnswers = (k) => {
    let title, answer
    
    switch (k) {
      case "goals":
        title = 'You want:'
        break;
      case "plan":
        title = 'Your Style:'
        break;
    
      default:
        title = 'Your hair:'
        break;
    }
    switch (k) {
      case "length":
        answer = answers[k] + ' - length'
        break;
      default:
        if (Array.isArray(answers[k])) {
          answer = answers[k].join(', ');
        } else {
          answer = answers[k]
        }
        break;
    }
    return <li key={k}>{title} { answer }</li>
  }

  return (
    <div className="Section Section--assessmentResults">
      {/* <div className="Section__header">
        <h5 className="heading">Your unique hair profile</h5>
      </div> */}
      <div className="Section__content">
        <ul>{Object.keys(answers).map(k => renderAnswers(k))}</ul>
      </div>
    </div>
  )
}



export default AssessmentResults;